import openkit from "openkit";
import { calculateNumberOfNights } from "./dates";
import { API_URL } from "../config/config";

openkit.config.app_url = API_URL;

const getProductPriceForDateRange = async (
  productId,
  standardPrice,
  startDate,
  endDate
) => {
  const dateRecords = await openkit.data.find("c_products_calendar", {
    product_id: productId,
    date: {
      _gte: startDate,
      _lt: endDate,
    },
    // _select: ["id"],
  });

  const totalPriceOfCalendarRecords = dateRecords.reduce(
    (a, c) => a + c.price,
    0
  );

  const numberOfNights = calculateNumberOfNights(startDate, endDate);

  const totalPrice =
    totalPriceOfCalendarRecords +
    (numberOfNights - dateRecords.length) * standardPrice;

  return totalPrice;
};

const getProductPriceForDate = async (productId, standardPrice, date) => {
  const data = await openkit.data.findOne("c_products_calendar", {
    product_id: productId,
    date: date,
    // _select: ["id"],
  });

  return data?.price || standardPrice;
};

// finds the minimum quantity available in the date range
const getNumberAvailable = async (productId, startDate, endDate) => {
  const dateRecords = await openkit.data.find("c_products_calendar", {
    product_id: productId,
    date: {
      _gte: startDate,
      _lt: endDate,
    },
    // _select: ["id"],
  });

  let quantityArray = [];
  for (const dr of dateRecords) {
    if (dr.quantity) quantityArray.push(dr.quantity);
  }

  const numberOfNights = calculateNumberOfNights(startDate, endDate);

  let min;
  // if there isn't a calendar value for all the days of the date range
  // it means some days will have the default quantity (stored in the products' info at c_products)
  if (quantityArray.length === numberOfNights) {
    min = Math.min(...quantityArray);
  } else {
    const productQuantityObj = await openkit.data.findOne("c_products", {
      id: productId,
      _select: ["gen_quantity"],
    });
    const defaultQuantity = productQuantityObj.gen_quantity;

    // will return NaN if quantityArray=[] and defaultQuantity = null
    if (defaultQuantity) min = Math.min(...quantityArray, defaultQuantity);
    else min = 9999;
  }

  return min;
};

export {
  getProductPriceForDate,
  getProductPriceForDateRange,
  getNumberAvailable,
};
